<template>
  <div>
    <img
      :src="src"
      :alt="alt"
      :class="iconsClass"
    >
  </div>
</template>

<script>
export default {
    name: 'TreeCardIcon',
    props: {
        src: {
            type: String,
            default: '',
        },
        custumeIconsClass20: {
            type: Boolean,
            default: false,
        },
        custumeIconsClass: {
            type: Boolean,
            default: false,
        },
        alt: {
            type: String,
            default: 'icon',
        },
        showBorder: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        iconsClass() {
            if (this.showBorder) {
                return 'icon-size showBorder';
            }
            if (this.custumeIconsClass20) {
                return 'custumeIconsClass20';
            }
            if (this.custumeIconsClass) {
                return 'custumeIconsClass';
            }
            return 'icon-size';
        },
    },
};
</script>
<style lang="scss">
.icon-size {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 1px;
}
.showBorder {
    border: #2A3E53 solid 2px;
    padding: 5px;
    border-radius: 2px;
}
.custumeIconsClass20{
width: 1rem;
}
.custumeIconsClass{
width: 20px;
    position: relative;
    top: 4px;
}
</style>
